import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import {
  Form,
  FormHeader,
  FormFooter,
  FormBack,
  FormSubmit
} from "cw-styleguide-react";
import withAssets from "../../../../components/hoc/withAssets";
import { STEP_SESSION_DETAILS, STEP_SESSION_VIEW } from "../../../../constants";

class SessionsCreateStep extends Component {

  render() {
    return (
      <Form multi={true}>
        <FormHeader title={this.props.t('local:view.courses.create.tabs.sessions.step.create.title')}
          introduction={this.props.t('local:view.courses.create.tabs.sessions.step.create.introduction')} />
        <FormFooter>
          {this.props.sessions.length > 0 &&
            <FormBack onClick={(e) => this.props.handleSetStep(e, STEP_SESSION_VIEW)}>
              {this.props.t('local:view.courses.create.tabs.sessions.callToAction')}
            </FormBack>
          }
          <FormSubmit onClick={(e) => this.props.handleSetStep(e, STEP_SESSION_DETAILS)}>
            {this.props.t('local:view.courses.create.tabs.sessions.step.create.callToAction')}
          </FormSubmit>
        </FormFooter>
      </Form>
    );
  }

}

export default withAssets(withTranslation('local')(SessionsCreateStep));
